import { SimpleTable } from "@/core/components/simple-table";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyHeader,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import type { IcmJob } from "@/icm/types";
import { getTableMinWidth } from "@/icm/utils";
import {
  BusinessUnitNameCol,
  CustomerNameCol,
  JobCompletedOnCol,
  JobTotalCol,
  JobTotalPayoutCol,
} from "./cols";

const JOB_COLUMNS = [
  CustomerNameCol,
  BusinessUnitNameCol,
  JobCompletedOnCol,
  JobTotalCol,
  JobTotalPayoutCol,
];
const JOB_TABLE_MIN_WIDTH = getTableMinWidth(JOB_COLUMNS);

interface IcmJobBreakdownTableProps {
  jobs: IcmJob[];
  searchValue: string;
  setSearchValue: (value: string) => void;
  onRowClick: (job: IcmJob | null) => void;
}

export const IcmJobBreakdownTable = ({
  jobs,
  searchValue,
  setSearchValue,
  onRowClick,
}: IcmJobBreakdownTableProps) => (
  <SimpleTable
    emptyContent={
      <Empty className={emptyStateVariants({ layout: "collection" })}>
        <EmptyHeader>
          <EmptyTitle>
            {searchValue?.trim()
              ? "No results match your search"
              : "No results for this period"}
          </EmptyTitle>
        </EmptyHeader>
        {searchValue?.trim() && (
          <EmptyContent>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setSearchValue?.("")}
            >
              Clear search
            </Button>
          </EmptyContent>
        )}
      </Empty>
    }
    data={jobs}
    columns={JOB_COLUMNS}
    getRowId={(row) => String(row.job_id ?? row.customer_name)}
    columnPinning={{ left: ["customer_name"], right: ["total_payout"] }}
    increaseHeaderPadding
    searchValue={searchValue}
    setSearchValue={setSearchValue}
    scrollAreaHeightClassName="h-[58vh]"
    scrollAreaClassName="pr-0"
    onRowClick={onRowClick}
    scrollContentStyle={{ minWidth: JOB_TABLE_MIN_WIDTH }}
  />
);
